import institutionAPI from 'services/institutionAPI'

type Params = {
  salaryId: string
}

export default async function getSalaryOnCustomForm({ salaryId }: Params) {
  const response = await institutionAPI({
    method: 'GET',
    url: `/citizen-portal/service/salary/${salaryId}`,
  })

  return response
}
